import {Service, service, inject} from "./di";
import {ConfigService, RuntimeConfig} from "./ConfigService";
import { fetchJSON, FetchOptions } from "../utils/fetch";
import { LocationService } from "./LocationService";
import MetadataService from "./MetadataService";
import Slot = googletag.Slot;

interface AdData {
	unit_id: string;
	custom_targetting: {
		[key: string]: any[]
	};
}

export const FLYER_LIST_AD_SLOT_ID = "flyer-list-ad-slot";
export const FLYER_LIST_AD_SLOT_POSITION_INDEX = 3;

@service("brandMediaService")
export class BrandMediaService extends Service {
	@inject config: ConfigService;
	@inject location: LocationService;
	@inject meta: MetadataService;

	private _shouldDisplayAd = false;

	shouldDisplayAd() {
		return this._shouldDisplayAd;
	}

	disableAd() {
		this._shouldDisplayAd = false;
	}

	async init() {
		await this.getBrandMediaData().then(data => {
			window.googletag = window.googletag || {cmd: []} as any;
			const configureSlot = (ad: AdData, slotId: string): Slot => {
				const slot = googletag.defineSlot(ad.unit_id, ["fluid"], slotId).addService(googletag.pubads());
				Object.keys(ad.custom_targetting).map(key => {
					slot.setTargeting(key, ad.custom_targetting[key][0]);
				});
				return slot;
			};
			googletag.cmd.push(() => {
				configureSlot(data[0].native_ads[0], FLYER_LIST_AD_SLOT_ID);
				googletag.pubads().enableSingleRequest();
				googletag.enableServices();
			});
		}).catch(e => {
			console.log(e);
		});
	}

	async getBrandMediaData() {
		const location = await this.location.getLocationInfo();
		const locale = this.meta.getLocale();
		const countryCode = location.country_code_by_postal_code ? location.country_code_by_postal_code : location.country_code_by_ip;
		const body = {
			country_code: countryCode.toLowerCase(),
			postal_code: location.postal_code,
			locale
		};
		const bodyFlyerList = JSON.stringify({
			...body,
			"page": "flyer_list"
		});
		const bodySearch = JSON.stringify({
			...body,
			"page": "search"
		});
		const opts: FetchOptions = {
			url: `${this.config.FLIPP_ADS_APIS}`,
			method: "POST",
			headers: [
				{"Content-Type": "application/json"}
			]
		};
		try {
			return Promise.all([
				fetchJSON<any>({...opts, body: bodyFlyerList}),
				fetchJSON<any>({...opts, body: bodySearch}),
			]);
		} catch (e) {
			console.log(e);
		}
	}

}
